module.exports = __webpack_public_path__ + "img/certificate-IM-3.5-4.5.e707fcc9.png";